import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { ServiceAppService } from './../../../security/service-app.service';
import { IFiltros, ITotais } from './interface-apuracao-vdm-peca';
import { ApuracaoVdmHistoricoPecaComponent } from './apuracao-vdm-historico-peca/apuracao-vdm-historico-peca.component';
import { ApuracaoVdmPrincipalPecaComponent } from './apuracao-vdm-principal-peca/apuracao-vdm-principal-peca.component';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { CurrencyPipe } from '@angular/common';
import { ApuracaoVdmPecaService } from './apuracao-vdm-peca.service';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-apuracao-vdm-peca',
  templateUrl: './apuracao-vdm-peca.component.html',
  styleUrls: ['./apuracao-vdm-peca.component.scss']
})
export class ApuracaoVdmPecaComponent implements OnInit, OnDestroy {
  cols: any[];
  colsFooter: any[];
  dados: any[];
  loading: boolean;
  nomeModulo: string;
  private subscription: Subscription = new Subscription();

  filtros: IFiltros = {
    dataAno: null,
    considerarBalcao: false,
    selecaoVdm: true
  };

  //Váriáveis do dropDown de Ano para o filtro.
  ano: any;
  anoAtual = new Date();
  anoAnterior = new Date();
  anoRetrasado = new Date();
  anoPosterior = new Date();
  anoDropDown: any[] = [];

  totais: ITotais = {
    totalBudgetFull: 0,
    totalBudgetYtd: 0,
    totalPendenteFull: 0,
    totalPendenteYtd: 0,
    totalRealizado: 0,
    totalValorDesconto: 0,
    totalValorComDesconto: 0
  }

  parametros: string = '';

  @ViewChild('dt') dt: Table;
  @ViewChild('principal') apuracaoVdmPrincipal: ApuracaoVdmPrincipalPecaComponent;
  @ViewChild('historico') apuracaoVdmHistorico: ApuracaoVdmHistoricoPecaComponent
  
  constructor(
    private service: ServiceAppService,
    private exportExcelService: ExportExcelService,
    private currency: CurrencyPipe,
    private apuracaoVdmService: ApuracaoVdmPecaService
  ) {
    this.nomeModulo = 'Apuração VDM - Peças';
  }

  ngOnInit(): void {
    this.geraAnoDropDown();
    this.setaValorData();

    this.cols = [
      { field: 'b_codDealer', header: 'Dealer' },
      { field: 'c_nomeDealer', header: 'Nome' },
      { field: 'd_budgetFull', header: 'Budget Full', type: this.currency, arg1: 'BRL' },
      { field: 'e_budgetYtd', header: 'Budget YTD', type: this.currency, arg1: 'BRL' },
      { field: 'f_realizado', header: 'Realizado', type: this.currency, arg1: 'BRL' },
      { field: 'n_valorDesconto', header: 'Valor Desconto', type: this.currency, arg1: 'BRL' },
      { field: 'o_valorComDesconto', header: 'Valor c/ Desconto', type: this.currency, arg1: 'BRL' },
      { field: 'g_pendenteFull', header: 'Pendente Full', type: this.currency, arg1: 'BRL' },
      { field: 'h_pendenteYtd', header: 'Pendente YTD', type: this.currency, arg1: 'BRL' },
    ];
  }

  ngAfterViewInit() {
    this.carregarDados();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  carregarDados() {
    this.subscription.add(
      this.apuracaoVdmService.carregarDados(this.filtros).subscribe(data => {
        this.dados = data.dados;
        this.totais = data.totais;
        
        // Notifica os componentes filhos que os dados foram carregados
        if (this.apuracaoVdmPrincipal) {
          this.apuracaoVdmPrincipal.atualizarDados(data);
        }
        if (this.apuracaoVdmHistorico) {
          this.apuracaoVdmHistorico.atualizarDados(data);
        }
      })
    );

    this.subscription.add(
      this.apuracaoVdmService.loading$.subscribe(loading => {
        this.loading = loading;
      })
    );
  }

  retornaDados() {
    // Força o refresh dos dados e recarrega as grids
    this.subscription.add(
      this.apuracaoVdmService.refreshDados(this.filtros).subscribe(data => {
        this.dados = data.dados;
        this.totais = data.totais;
        
        // Notifica os componentes filhos que os dados foram carregados
        if (this.apuracaoVdmPrincipal) {
          this.apuracaoVdmPrincipal.atualizarDados(data);
        }
        if (this.apuracaoVdmHistorico) {
          this.apuracaoVdmHistorico.atualizarDados(data);
        }
      })
    );

    this.subscription.add(
      this.apuracaoVdmService.loading$.subscribe(loading => {
        this.loading = loading;
      })
    );
  }

  setaValorData() {
    if (this.filtros.dataAno === undefined || this.filtros.dataAno === null) {
      var data = new Date();
      var mes = String(data.getMonth() + 1).padStart(2, '0')
      if (parseInt(mes) == 1 || parseInt(mes) == 2 || parseInt(mes) == 3) {
        this.filtros.dataAno = this.anoPosterior.getFullYear() - 1;
      } else {
        this.filtros.dataAno = this.anoAtual.getFullYear();
      }
    }

    this.carregarDados();
  }

  alteraValorFiltroVdm() {
    this.carregarDados();
  }

  set Ano(ano: any) { this.filtros.dataAno = this.tratarSetDropDown(ano); }
  get Ano(): any { return this.tratarGetDropDown(this.filtros.dataAno); }

  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  private geraAnoDropDown() {
    this.anoDropDown = [
      { name: this.anoRetrasado.getFullYear() - 2, code: this.anoRetrasado.getFullYear() - 2 },
      { name: this.anoAnterior.getFullYear() - 1, code: this.anoAnterior.getFullYear() - 1 },
      { name: this.anoAtual.getFullYear(), code: this.anoAtual.getFullYear() },
      { name: this.anoPosterior.getFullYear() + 1, code: this.anoPosterior.getFullYear() + 1 }
    ]
  }

  // Função para garantir valores válidos e formatados para o Excel
  private sanitizeExcelValue(value: any, isNumeric: boolean = false): any {
    if (value === null || value === undefined || value === '') {
      return isNumeric ? 0 : '';
    }
    
    if (isNumeric) {
      // Remove qualquer formatação e converte para número puro
      let cleanValue = value;
      if (typeof value === 'string') {
        // Remove símbolos de moeda, pontos, vírgulas e espaços
        cleanValue = value.replace(/[R$\s]/g, '').replace(/\./g, '').replace(/,/g, '.');
      }
      const num = parseFloat(cleanValue);
      if (isNaN(num)) {
        return 0;
      }
      // Retorna o número puro para permitir somatórias no Excel
      return num;
    }
    return String(value).replace(/[\x00-\x1F\x7F]/g, '').substring(0, 255);
  }

  public exportExcel() {
    // Para exportação, fazemos uma requisição direta para garantir os dados originais
    // sem processamento adicional do service
    this.service.getDados(`/apuracao_vdm_peca?dataAno=${this.filtros.dataAno}&selecaoVdm=${this.filtros.selecaoVdm}&considerarBalcao=${this.filtros.considerarBalcao}`).subscribe(res => {
      const registros = res.dados;
      if (registros.length > 0) {
        this.exportarDadosPrincipais(registros);
        this.exportarDadosPrincipal(registros);
        this.exportarDadosHistorico(registros);
      }
    });
  }

  private exportarDadosPrincipais(registros: any[]) {
    if (registros.length > 0) {
      this.exportExcelService.nomeModulo = this.nomeModulo;
      this.exportExcelService.colunasFormatacao = [2, 3, 4, 5, 6, 7, 8]; // Colunas monetárias
      this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
        let linha = {};
        this.cols.forEach(c => {
          let valor;
          const isMonetary = c.type === this.currency;
          
          if (c.field === 'b_codDealer') {
            valor = this.sanitizeExcelValue(r['b_codDealer'], false);
          } else if (c.field === 'c_nomeDealer') {
            valor = this.sanitizeExcelValue(r['c_nomeDealer'], false);
          } else if (c.field === 'd_budgetFull') {
            valor = this.sanitizeExcelValue(r['d_budgetFull'], true);
          } else if (c.field === 'e_budgetYtd') {
            valor = this.sanitizeExcelValue(r['e_budgetYtd'], true);
          } else if (c.field === 'f_realizado') {
            valor = this.sanitizeExcelValue(r['f_realizado'], true);
          } else if (c.field === 'n_valorDesconto') {
            valor = this.sanitizeExcelValue(r['n_valorDesconto'], true);
          } else if (c.field === 'o_valorComDesconto') {
            valor = this.sanitizeExcelValue(r['o_valorComDesconto'], true);
          } else if (c.field === 'g_pendenteFull') {
            valor = this.sanitizeExcelValue(r['g_pendenteFull'], true);
          } else if (c.field === 'h_pendenteYtd') {
            valor = this.sanitizeExcelValue(r['h_pendenteYtd'], true);
          } else {
            valor = this.sanitizeExcelValue(r[c.field], isMonetary);
          }
          linha[c.header] = valor;
        });
        return linha;
      }));
    }
  }

  private exportarDadosPrincipal(registros: any[]) {
    if (registros.length > 0) {
      this.exportExcelService.nomeModulo = "Apuração VDM - Peças/Principal";
      this.exportExcelService.colunasFormatacao = [2, 3, 4, 5, 6, 7, 8]; // Colunas monetárias
      this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
        let linha = {};
        this.apuracaoVdmPrincipal.cols.forEach(c => {
          let valor;
          const isMonetary = c.type === this.currency;
          
          if (c.field === 'b_codDealer') {
            valor = this.sanitizeExcelValue(r['b_codDealer'], false);
          } else if (c.field === 'c_nomeDealer') {
            valor = this.sanitizeExcelValue(r['c_nomeDealer'], false);
          } else if (c.field === 'i_budgetFullMes') {
            valor = this.sanitizeExcelValue(r['d_budgetFull'], true);
          } else if (c.field === 'j_budgetMtd') {
            valor = this.sanitizeExcelValue(r['e_budgetYtd'], true);
          } else if (c.field === 'k_realizadoMes') {
            valor = this.sanitizeExcelValue(r['k_realizadoMes'], true);
          } else if (c.field === 'n_valorDesconto') {
            valor = this.sanitizeExcelValue(r['n_valorDesconto'], true);
          } else if (c.field === 'o_valorComDesconto') {
            valor = this.sanitizeExcelValue(r['o_valorComDesconto'], true);
          } else if (c.field === 'l_gapMesFull') {
            valor = this.sanitizeExcelValue(r['l_gapMesFull'], true);
          } else if (c.field === 'm_gapMesYtd') {
            valor = this.sanitizeExcelValue(r['m_gapMesYtd'], true);
          } else {
            valor = this.sanitizeExcelValue(r[c.field], isMonetary);
          }

          linha[c.header] = valor;
        });
        return linha;
      }));
    }
  }

  private exportarDadosHistorico(registros: any[]) {
    if (registros.length > 0) {
      // Processar os dados do histórico da mesma forma que o componente faz
      const registrosProcessados = registros.map(el => {
        // Aplicar o mesmo processamento que era feito no componente histórico
        el.abrGap = el.mensal?.abrGap || 0;
        el.abrObjetivo = el.mensal?.abrObjetivo || 0;
        el.abrPercent = el.mensal?.abrPercent || 0;
        el.abrRealizado = el.mensal?.abrRealizado || 0;
        el.agoGap = el.mensal?.agoGap || 0;
        el.agoObjetivo = el.mensal?.agoObjetivo || 0;
        el.agoPercent = el.mensal?.agoPercent || 0;
        el.agoRealizado = el.mensal?.agoRealizado || 0;
        el.dezGap = el.mensal?.dezGap || 0;
        el.dezObjetivo = el.mensal?.dezObjetivo || 0;
        el.dezPercent = el.mensal?.dezPercent || 0;
        el.dezRealizado = el.mensal?.dezRealizado || 0;
        el.fevGap = el.mensal?.fevGap || 0;
        el.fevObjetivo = el.mensal?.fevObjetivo || 0;
        el.fevPercent = el.mensal?.fevPercent || 0;
        el.fevRealizado = el.mensal?.fevRealizado || 0;
        el.janGap = el.mensal?.janGap || 0;
        el.janObjetivo = el.mensal?.janObjetivo || 0;
        el.janPercent = el.mensal?.janPercent || 0;
        el.janRealizado = el.mensal?.janRealizado || 0;
        el.julGap = el.mensal?.julGap || 0;
        el.julObjetivo = el.mensal?.julObjetivo || 0;
        el.julPercent = el.mensal?.julPercent || 0;
        el.julRealizado = el.mensal?.julRealizado || 0;
        el.junGap = el.mensal?.junGap || 0;
        el.junObjetivo = el.mensal?.junObjetivo || 0;
        el.junPercent = el.mensal?.junPercent || 0;
        el.junRealizado = el.mensal?.junRealizado || 0;
        el.maiGap = el.mensal?.maiGap || 0;
        el.maiObjetivo = el.mensal?.maiObjetivo || 0;
        el.maiPercent = el.mensal?.maiPercent || 0;
        el.maiRealizado = el.mensal?.maiRealizado || 0;
        el.marGap = el.mensal?.marGap || 0;
        el.marObjetivo = el.mensal?.marObjetivo || 0;
        el.marPercent = el.mensal?.marPercent || 0;
        el.marRealizado = el.mensal?.marRealizado || 0;
        el.novGap = el.mensal?.novGap || 0;
        el.novObjetivo = el.mensal?.novObjetivo || 0;
        el.novPercent = el.mensal?.novPercent || 0;
        el.novRealizado = el.mensal?.novRealizado || 0;
        el.outGap = el.mensal?.outGap || 0;
        el.outObjetivo = el.mensal?.outObjetivo || 0;
        el.outPercent = el.mensal?.outPercent || 0;
        el.outRealizado = el.mensal?.outRealizado || 0;
        el.q1Gap = el.mensal?.q1Gap || 0;
        el.q1Objetivo = el.mensal?.q1Objetivo || 0;
        el.q1Percent = el.mensal?.q1Percent || 0;
        el.q1Realizado = el.mensal?.q1Realizado || 0;
        el.q2Gap = el.mensal?.q2Gap || 0;
        el.q2Objetivo = el.mensal?.q2Objetivo || 0;
        el.q2Percent = el.mensal?.q2Percent || 0;
        el.q2Realizado = el.mensal?.q2Realizado || 0;
        el.q3Gap = el.mensal?.q3Gap || 0;
        el.q3Objetivo = el.mensal?.q3Objetivo || 0;
        el.q3Percent = el.mensal?.q3Percent || 0;
        el.q3Realizado = el.mensal?.q3Realizado || 0;
        el.q4Gap = el.mensal?.q4Gap || 0;
        el.q4Objetivo = el.mensal?.q4Objetivo || 0;
        el.q4Percent = el.mensal?.q4Percent || 0;
        el.q4Realizado = el.mensal?.q4Realizado || 0;
        el.setGap = el.mensal?.setGap || 0;
        el.setObjetivo = el.mensal?.setObjetivo || 0;
        el.setPercent = el.mensal?.setPercent || 0;
        el.setRealizado = el.mensal?.setRealizado || 0;
        return el;
      });

      this.exportExcelService.nomeModulo = "Apuração VDM - Peças/Histórico";
      this.exportExcelService.colunasFormatacao = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48]; // Todas as colunas monetárias do histórico
      this.exportExcelService.ExportTOExcelJSON(registrosProcessados.map(r => {
        let linha = {};
        this.apuracaoVdmHistorico.cols.forEach(c => {
          let valor;
          const isMonetary = c.header.includes('Realizado') || c.header.includes('Objetivo') || c.header.includes('Gap');
          
          if (c.field === 'b_codDealer') {
            valor = this.sanitizeExcelValue(r['b_codDealer'], false);
          } else if (c.field === 'c_nomeDealer') {
            valor = this.sanitizeExcelValue(r['c_nomeDealer'], false);
          } else {
            valor = this.sanitizeExcelValue(r[c.field], isMonetary);
          }
          linha[c.header] = valor;
        });
        return linha;
      }));
    }
  }
  downloadExcel(dados: any) {
    this.apuracaoVdmService.downloadAnalitico(dados.b_codDealer, this.filtros).subscribe({
      next: (response: any[]) => {
        const dadosFormatados = response.map((item: any) => ({
          'Cod. Dealer': this.sanitizeExcelValue(item.codDealer, false),
          'Nome Dealer': this.sanitizeExcelValue(item.nomeDealer, false),
          'Data Emissão': this.formatarDataHora(item.dataEmissao),
          'Valor Realizado': this.sanitizeExcelValue(item.valorRealizado, true),
          'Valor Desconto': this.sanitizeExcelValue(item.valorDesconto, true),
          'Valor c/ Desconto': this.sanitizeExcelValue(item.valorComDesconto, true),
          'Código': this.sanitizeExcelValue(item.codigo, false),
          'Nota': this.sanitizeExcelValue(item.nota, false),
          'Número OS': this.sanitizeExcelValue(item.numeroOs, false),
          'Tipo OS': this.sanitizeExcelValue(item.tipoOs, false)
        }));

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dadosFormatados);
        const workbook: XLSX.WorkBook = { Sheets: { 'Analitico': worksheet }, SheetNames: ['Analitico'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        const urlBlob = window.URL.createObjectURL(blob);
        link.href = urlBlob;
        link.download = 'analitico_apuracao_vdm_peca.xlsx';
        link.click();
        window.URL.revokeObjectURL(urlBlob);
      },
      error: (err) => {
        console.error('Erro ao gerar arquivo:', err);
      }
    });
  }

  formatarDataHora(dataHora: string): string {
    if (!dataHora) return '';

    const [dataParte, horaParte] = dataHora.split(' ');
    const [ano, mes, dia] = dataParte.split('-');
    const horaLimpa = horaParte ? horaParte.split('.')[0] : '';

    return `${dia}/${mes}/${ano} ${horaLimpa}`;
  }


}